import template from "./index.html";
import "./index.less";

//terms
export function controller() {
	const ctrl = this;

	ctrl.$onInit = onInit;

	function onInit() {
	}
}

export const singleExportDetail = angular
	.module("vesl.components.single-export-detail", [])
	.component("singleExportDetail", {
		controller,
		template,
		bindings: {
			export: "<"
		}
	}).name;
